import { SVGArrowLeft, SVGArrowRight } from "@/lib/svg";
import Link from "next/link";
import { useRouter } from "next/router";
import { Button, Container } from "./styles";

export type PaginationProps = {
  page: number;
  nbPages: number;
};

const Pagination: React.FC<PaginationProps> = (props) => {
  const { page, nbPages } = props;
  const { query } = useRouter();

  const prevPage = page - 1;
  const nextPage = page + 1;

  const hasNextPage = page < nbPages;
  const hasPrevPage = page >= 1;

  return (
    <Container>
      {hasPrevPage ? (
        <Link
          passHref
          href={{
            query: {
              ...query,
              page: prevPage,
            },
          }}
        >
          <Button icon={<SVGArrowLeft />}>Prev</Button>
        </Link>
      ) : (
        <div></div>
      )}
      {hasNextPage && (
        <Link
          passHref
          href={{
            query: {
              ...query,
              page: nextPage,
            },
          }}
        >
          <Button icon={<SVGArrowRight />}>Next</Button>
        </Link>
      )}
    </Container>
  );
};

export default Pagination;
